import MuiAvatar from '@mui/material/Avatar'

import { Batch } from '#/components/FormatCell/Types/AvatarLink'
import { Icon } from '#/components/Icon'
import Colors from '#/styles/Colors'

type AvatarBatchProps = {
  batch: Batch
}

function AvatarBatch({ batch }: AvatarBatchProps) {
  let backgroundColor

  if (batch?.monitored) {
    backgroundColor = Colors.devices.ctech.normal.backgroundColor
  }

  return (
    <MuiAvatar style={{ backgroundColor }}>
      <Icon size="large" name="batch" sx={{ fontSize: '28px' }} />
    </MuiAvatar>
  )
}

export { AvatarBatch }
